export const SET_CLASSES = 'SET_CLASSES';
export const SET_CLASS = 'SET_CLASS';
export const ADD_CLASS = 'ADD_CLASS';
export const UPDATE_CLASS = 'UPDATE_CLASS';
export const REMOVE_CLASS = 'REMOVE_CLASS';
export const CLEAR_CLASS = 'CLEAR_CLASS';
export const CLEAR_CLASSES = 'CLEAR_CLASSES';
